import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import styled from 'styled-components';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import GenericModal from './generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';

const Subtitle = styled.div`
	font-size: 11px;
	max-width: 400px;
	margin-bottom: 12px;
`;

class SelectModalV2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: this.props.initialValue ? this.props.initialValue : null,
		};
	}

	handleSelectChange(selected) {
		this.setState({selected: selected});
	}

	onConfirm() {
		this.props.defaultCallback(this.state.selected);
		this.props.closeModal();
	}

	render() {
		const {formatMessage} = this.props.intl;

		const content = (
			<div className="content">
				{this.props.subTitle ? <Subtitle>{this.props.subTitle}</Subtitle> : null}
				{this.props.emptyText && this.props.options.length === 0 ? (
					<Subtitle>{this.props.emptyText}</Subtitle>
				) : (
					<Dropdown
						options={this.props.options}
						onChange={this.handleSelectChange.bind(this)}
						label={this.props.label || ''}
						multi={this.props.multi || false}
						value={this.props.multi ? this.state.selected : this.state.selected ? this.state.selected.value : null}
						focusOnMount={true}
						maxHeight={window.innerHeight !== undefined && window.innerHeight < 850 ? 300 : undefined}
						isPersonSelector={this.props.personSelect}
						personImageSize={'24'}
						dataCy={'select-modal-dropdown'}
						listDataCy={'select-modal-dropdown-list'}
					/>
				)}
			</div>
		);
		return (
			<GenericModal
				closeModal={this.props.closeModal}
				buttons={[
					{
						text: formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.update'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.GREEN,
						callback: this.onConfirm.bind(this),
						disabled:
							!this.state.selected || (this.props.multi && this.state.selected && !this.state.selected.length),
						cy: 'update-button',
					},
				]}
				headerText={this.props.title}
				content={content}
			/>
		);
	}
}
SelectModalV2.propTypes = {
	closeModal: PropTypes.func.isRequired,
	options: PropTypes.array.isRequired,
	label: PropTypes.string,
	multi: PropTypes.bool,
	initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	defaultCallback: PropTypes.func.isRequired,
};

export default injectIntl(SelectModalV2);
